import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=3b73ee7d&scoped=true"
import script from "./LinkCard.vue?vue&type=script&lang=js"
export * from "./LinkCard.vue?vue&type=script&lang=js"
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=3b73ee7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b73ee7d",
  null
  
)

export default component.exports